import { Groups } from '../../services';
import { createRestSlices, createGenericSlice, applyReducers } from './rest';

const {
    initialState,

    createReducer, startCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,

    startCreateAction: startCreateGroup,
    createAction: createGroup,
    getAction: loadGroup,
    listAction: loadGroups,
    updateAction: updateGroup,
    deleteAction: deleteGroup,
} = createRestSlices(Groups);

// remove student generic slice
const { reducer: removeStudentReducer, action: removeStudentFromGroup } = createGenericSlice(Groups, {
    name: 'removeStudent',
    action: (group, student) => Groups.removeStudent(group, student),
    onSuccess: (state, action) => ({ ...state, group: action.group }),
    onError: (state, error) => ({ ...state }),
});

// remove classroom generic slice
const { reducer: removeClassroomReducer, action: removeClassroomFromGroup } = createGenericSlice(Groups, {
    name: 'removeClassroom',
    action: (group, classroom) => Groups.removeClassroom(group, classroom),
    onSuccess: (state, action) => ({ ...state, group: action.group }),
    onError: (state, error) => ({ ...state }),
});

/* Export reducers */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        removeStudentReducer, removeClassroomReducer
    ]);
}

/* Export actions */
export {
    startCreateGroup, createGroup,
    loadGroup, loadGroups,
    updateGroup, deleteGroup,
    removeStudentFromGroup,
    removeClassroomFromGroup
};
